const ICON_ASSET_BY_VALUE = {
  "📘": "book",
  "📚": "books",
  "✏️": "pencil",
  "📝": "worksheet",
  "🧮": "abacus",
  "🔢": "numbers",
  "📐": "ruler",
  "🔬": "microscope",
  "🧪": "flask",
  "🔭": "telescope",
  "🌍": "globe",
  "🎨": "palette",
  "🎵": "music",
  "💻": "laptop",
  "📊": "chart",
  "💡": "idea",
  "🎲": "dice",
};

export function getTaskIconAsset(value) {
  return ICON_ASSET_BY_VALUE[value] || "book";
}

export default function TaskIcon({ value = "📘", className = "" }) {
  return (
    <img
      src={`/task-icons/${getTaskIconAsset(value)}.png`}
      alt=""
      className={className}
      draggable="false"
    />
  );
}
